import React, { ReactNode, useState } from "react";
import { Tooltip } from "./Tooltip.tsx";

interface CircleMenuItemProps {
  onClick: () => void;
  children?: ReactNode;
  icon?: ReactNode;
  label: string;
  disabled?: boolean;
}

const CircleMenuItem: React.FC<CircleMenuItemProps> = ({
  onClick,
  children,
  icon,
  label,
  disabled = false,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Tooltip show={showTooltip} label={label}>
      <div
        id={`circle-menu-item-${label.toLowerCase().split(" ").join("-")}`}
        className="flex flex-col items-center relative"
      >
        <button
          onClick={onClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          disabled={disabled}
          className={`w-12 h-12 rounded-full bg-white shadow-lg border-2 border-gray-200 flex items-center justify-center transition-all duration-200 text-gray-600 ${
            disabled
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-secondary-light hover:text-white hover:border-secondary-light"
          }`}
          aria-label={label}
        >
          {icon || children}
        </button>
      </div>
    </Tooltip>
  );
};

export { CircleMenuItem };
